import React from 'react';
import Layout from '../components/Layout';
import SamplingSystemAlert from '../components/SamplingSystemAlert';

const Page: React.FC = () => {
  return (
    <Layout loggedIn={false}>
      <SamplingSystemAlert />
    </Layout>
  );
};

export default Page;
